module.exports = __webpack_public_path__ + "static/img/well.319d555.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/address/well.jpg
// module id = nCOu
// module chunks = 0